import styled from 'styled-components'

export const AppIconAndHyperlinkContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-left: 2px;
    padding-right: 2px;
    margin-bottom: 10px;
`
